import React, { Component } from 'react';
import Header from "./Header";

import data from './data-links.json';
 
class Techlinks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: data,
};
}
  render() {
    return (

<div className="Technical">
<Header>
</Header>   
       
        <h2>Tech Links</h2>
        {data.map(item =>
          <div key={item.id}>
            <span> 
            <a href={item.url}>{item.title}</a>
            </span>
           {/* <span>{item.author} </span>
           <span>{item.num_comments} </span>
           <span>{item.points} </span> */}
           </div>)
        } 
</div>
    );
  }
}
 
export default Techlinks;



// WEBPACK FOOTER //
// ./src/Techlinks.js